<div class="stars-container" [ngClass]="getErrorClass()">
  

  <!-- Estrellas del 1 al 5 -->
   <div class="stars-wrapper d-flex">
    <div class="star-column"
    *ngFor="let i of [1, 2, 3, 4, 5]"
    class="star-item star"
    [ngClass]="getStarClass(i)"
    (click)="onClick(i)"
    [title]="'Calificación: ' + i"
  >
    <i class="fas fa-star"></i>
  </div>

  

 
  </div>
   <!-- Icono de prohibido -->
  <div
    class="star-item prohibited my-2"
    [ngClass]="getProhibitedClass()"
    (click)="onClick(0)"
    title="No aplica"
  >
    <i class="fas fa-ban"></i>
    <span>No aplica</span>
  </div>
</div>
